import CardMyFavorite from '../Components/CardMyFavorite'
import { useSelector } from 'react-redux'

function MyFavorite () {
  const dataMyFavoritAmibo = useSelector(state => state.myFavoritAmibo.dataMyFavoritAmibo)
    return (
      <div className="App">
        <h1 style={{textAlign: 'center'}} className="m-4">My Favorite</h1>
        <div className="container">
          <div className="row">
            {
              dataMyFavoritAmibo.map((dataFavoritAmibo, index) => (
                <div key= {index}>
                  <CardMyFavorite data={dataFavoritAmibo}/>
                </div>
              ))
            }
          </div>
        </div>
      </div>
    ) 
  }


export default MyFavorite